import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const InctvClaimLineList = ({ inctvClaimObj: inctvClaim }) => {

  const augRowsReq = useCallback((rowsReq) => {

    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('inctvClaimId', inctvClaim.id,
      'rbtPeriodId', inctvClaim.rbtPeriodId));
  }, []);

  return (
    <EntityList entity="INCTV_CLAIM_LINE" augRowsReq={augRowsReq} />
  )
}